import { Component, OnInit, inject } from '@angular/core';
import { Upload } from 'app/core/models/upload.model';
import { Client } from 'app/core/models/client.model';
import { ClientsService } from 'app/core/services/clients.service';
import { isEmpty } from 'lodash-es';
import { ClientEspNdcImportsService } from 'app/core/services/client-esp-ndc-imports.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';
import { FormsModule } from '@angular/forms';

import { FileUploadComponent } from '../../../shared/components/file-upload/file-upload.component';

const emptyForm = { clientId: null, file: null };

@Component({
    selector: 'app-capture-admin-import-client-esp-ndcs',
    templateUrl: './capture-admin-import-client-esp-ndcs.component.html',
    styleUrls: ['./capture-admin-import-client-esp-ndcs.component.scss'],
    imports: [
    ImportNavComponent,
    FormsModule,
    FileUploadComponent
],
})
export class CaptureAdminImportClientEspNdcComponent implements OnInit {
  private clientsService = inject(ClientsService);
  private clientEspNdcImportsService = inject(ClientEspNdcImportsService);
  private router = inject(Router);

  uploading = false;
  formModel = { ...emptyForm };
  errors: string[] = [];

  clients: Client[] = [];

  ngOnInit() {
    this.loadClients();
  }

  get uploadButtonDisabled(): boolean {
    return !(this.formModel.clientId && this.formModel.file);
  }

  onFileSelected(file) {
    this.formModel.file = file;
  }

  onUploadStart() {
    this.uploading = true;
    this.errors = [];
  }

  onUploadCancel() {
    this.uploading = false;
  }

  onUploadError() {
    this.uploading = false;
  }

  onUploadComplete(upload: Upload) {
    this.uploading = false;

    const clientId = parseInt(this.formModel.clientId, 10);

    this.clientEspNdcImportsService.create(clientId, upload.signedId).subscribe(
      () => {
        this.router.navigate(['/capture-admin/tools/import-client-esp-ndcs/history']);
      },
      (error: HttpErrorResponse) => {
        this.uploading = false;
        this.errors = error.error.errors;
      }
    );
  }

  onFormEnter($event) {
    $event.preventDefault();
  }

  private loadClients() {
    this.clientsService.getList(null, { applicableToReferralClaims: true }).subscribe(result => {
      this.clients = result.clients;
    });
  }

  public get hasError() {
    return !isEmpty(this.errors);
  }
}
